export enum WeightUnits {
    KILOS = "KILOS",
    GRAMS = "GRAMS",
    OUNCES = "OUNCES"
  }
